module.exports = __webpack_public_path__ + "img/api-warrior-silver.c020cafe.jpg";